<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <h4>Kunde benachrichtigen</h4>
        </div>
    </div>

    <div class="row ">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-accordion *ngFor="let template of this.templates">
                <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                           <span>
                            {{template.subject }}
                           </span>

                            <button mat-button color="primary" (click)="$event.stopPropagation();sendNotification(template)">
                                Senden
                        </button>
                        </mat-panel-title>
     
                    </mat-expansion-panel-header>
                    <div [innerHTML]="template.body"></div>
                    <button mat-raised-button color="primary" (click)="sendNotification(template)">
                        Senden
                </button>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>